<template>
  <InnerLayout>
    <template #banner>
      <BannerInner :text="teacherName"/>
    </template>
    <template #default>
      <ScheduleComponent :type="SCHEDULE_TYPE_TEACHER" :teacherName="teacherName"/>
    </template>
  </InnerLayout>
</template>

<script setup>
import {useRoute} from "vue-router";
import {SCHEDULE_TYPE_TEACHER} from "@/data/constants";
import InnerLayout from "@/layouts/InnerLayout.vue";
import BannerInner from "@/features/banners/components/BannerInner.vue";
import ScheduleComponent from "@/features/schedule/components/ScheduleComponent.vue";

const route = useRoute();
const {teacherName} = route.params;
</script>

<style lang="scss" scoped>

</style>